import { Injectable } from '@angular/core';
import { TYPE } from '../modules/shared/constants/software-button-var';
import { TranslateService } from '@ngx-translate/core';

declare var utag: any;

@Injectable({
  providedIn: 'root'
})
export class TealiumService {
  currentEnvironment = '';
  translationStringBasedOnKey = '';

  constructor(private translate: TranslateService) {
    setTimeout(() => {
      const hostName = window.location.hostname;
      if ((hostName.includes('dev')) || (hostName.includes('test'))) {
        this.currentEnvironment =  `qa`;
      } else if ((hostName.includes('localhost'))) {
        this.currentEnvironment =  `dev`;
      } else {
        this.currentEnvironment = `prod`;
      }
      (() => {
        let a: string, b: Document, c: string, d: HTMLScriptElement;
        a = `//tags.tiqcdn.com/utag/tomtom/navshop/${this.currentEnvironment}/utag.js`;
        b = document;
        c = 'script';
        d = b.createElement(c) as HTMLScriptElement;
        d.src = a;
        d.type = 'text/javascript';
        d.async = true;
        b.head.appendChild(d);
      })();
    }, 1000);
  }

  trackEvent(data: any) {
    utag.link(data);
  }

  identificationOfMapOrSoftwareDownloads(name: string, type: TYPE) {
    if (type === TYPE.BUTTON) {
      if(name.toLowerCase().includes('software')){
        return TYPE.CLICK_ON_SOFTWARE_BUTTON;
      } else {
        return TYPE.CLICK_ON_DOWNLOAD_BUTTON;
      }
    } else {
      if(name.toLowerCase().includes('software')){
        return TYPE.CLICK_ON_SOFTWARE_LINK;
      } else {
        return TYPE.CLICK_ON_DOWNLOAD_LINK;
      }
    }
  }

  getTranslationBasedOnKey(key: string) {
    this.translate.get(key).subscribe((res: any) => {
      this.translationStringBasedOnKey = res;
    });
    return this.translationStringBasedOnKey;
  }
}
